import consumer from "./consumer"


$(document).ready(function() {

  const element = document.getElementById('room-id');
  const room_id = element ? element.getAttribute('data-room-id') : '';
  const disenoPlanilla = element ? element.getAttribute('data-prioridad-diseno') === 'planilla' : false;
  var recursosLycras = {};

  if (disenoPlanilla) {
    recursosLycras = JSON.parse(element.getAttribute('data-prioridad-assets') || '{}');
  }

  console.log('room_id: ' + room_id);

  function createSquare(p,color,vacia) {
      var detallePrioridad = document.getElementById('detalle_prioridad');

      if (disenoPlanilla) {
        var prioridad = document.createElement('div');
        var contenido = document.createElement('div');
        var etiqueta = document.createElement('div');
        var posicion = parseInt(p.replace('P', '').replace(':S', ''), 10);

        prioridad.className = 'enlinea' + (p.endsWith(':S') ? ' parpadeo' : '');
        contenido.style.textAlign = 'center';
        contenido.style.marginLeft = posicion === 1 ? '0.4rem' : '1rem';
        etiqueta.textContent = p.replace(':S', ' S');

        contenido.appendChild(etiqueta);

        if (vacia) {
          var prioridadVacia = document.createElement('div');
          prioridadVacia.className = 'prioridad-vacia-planilla';
          prioridadVacia.style.width = '40px';
          prioridadVacia.style.height = '40px';
          prioridadVacia.style.margin = '0 auto';
          prioridadVacia.style.border = '1px solid black';
          prioridadVacia.style.borderRadius = '0.2rem';
          prioridadVacia.style.lineHeight = '38px';
          prioridadVacia.textContent = 'X';
          contenido.appendChild(prioridadVacia);
        } else {
          var contenedorImagen = document.createElement('div');
          var imagen = document.createElement('img');
          imagen.src = recursosLycras[color];
          imagen.className = 'max430_15 min_431_2';
          contenedorImagen.appendChild(imagen);
          contenido.appendChild(contenedorImagen);
        }

        prioridad.appendChild(contenido);
        detallePrioridad.appendChild(prioridad);
        return;
      }

      // Crear el div con clase "square enlinea red"
      var square = document.createElement('div');

      if (vacia) {
        square.className = 'square prioridad-vacia enlinea';
      } else if (p.endsWith(":S")) {
        //Si hay prioridad suspendida agregar clase para que parpadee
        square.className = 'square_s parpadeo enlinea '+ color;
      } else {
        square.className = 'square enlinea '+ color;
      }      

      // Crear el div interno con estilo de margen y texto "P1"
      var innerDiv = document.createElement('div');
      innerDiv.style.marginTop = '0.15rem';
      innerDiv.textContent = p.replace(':S', ' S');

      // Añadir el div interno al div "square"
      square.appendChild(innerDiv);

      // Añadir el div "square" al contenedor principal
      detallePrioridad.appendChild(square);
  };


  if (room_id != '' ){

    window.prioridadSubscription = consumer.subscriptions.create({channel: "PrioridadChannel", room:room_id},{
      connected() {
        // Called when the subscription is ready for use on the server
        console.log("Conectado al prioridad channel..." + room_id)
        
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(data) {
        // Called when there's incoming data on the websocket for this channel
        var datajson = JSON.parse(data);
        var detallePrioridad = document.getElementById('detalle_prioridad');
        var fondo_prioridad = document.getElementById('fondo_prioridad');

        document.dispatchEvent(new CustomEvent('prioridades:actualizadas', { detail: datajson }));

        if (detallePrioridad === null || fondo_prioridad === null) {
          return;
        }

        //Borrar las proiridades anteriores
        while (detallePrioridad.firstChild) {
            detallePrioridad.removeChild(detallePrioridad.firstChild);
        }

        //Crear los div con las nuevas prioridades
        var cont = 0;
        var numPrioridades = parseInt(element.getAttribute('data-num-prioridades'), 10);

        if (numPrioridades > 0) {
          for (var posicion = 1; posicion <= numPrioridades; posicion += 1) {
            var claveSuspendida = posicion + ':S';
            var clave = datajson[claveSuspendida] ? claveSuspendida : posicion.toString();
            createSquare('P' + clave, datajson[clave], !datajson[clave]);
            cont += 1;
          }
        } else {
          for (var key in datajson) {
            cont = cont + 1;
            createSquare("P"+key, datajson[key], false);
          }
        }

        //ajustar el ancho del fondo gris al número de prioridades
        if (cont >0 ){
          $("#con_sin_prioridades").removeClass("ocultar");
          if (!disenoPlanilla) {
            var wdt = cont*37
            fondo_prioridad.style.width = wdt+'px';
          }
        }
        else {
          $("#con_sin_prioridades").addClass("ocultar");
        }

      }
    });

  }


    
});
